document.addEventListener("DOMContentLoaded", function () {
  const comparisonTrigger = document.querySelector(".trigger-comparison");
  if (comparisonTrigger) {
    comparisonTrigger.addEventListener("click", showComparison2);
  }

  function showComparison2() {
    // Show modal
    const modal = document.getElementById("comparisonModal");

    setTimeout(() => {
      modal.classList.add("show");
    }, 10);

    // Close modal when clicking background
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        hideComparison();
      }
    });

    const closeBtn = document.querySelector(".close-btn");
    closeBtn.addEventListener("click", hideComparison);

    // Add keyboard event listener
    document.addEventListener("keydown", handleEscKey, { once: true });
  }

  function hideComparison() {
    const modal = document.getElementById("comparisonModal");
    if (modal) {
      modal.classList.remove("show");
      setTimeout(() => {
        document.removeEventListener("keydown", handleEscKey);
      }, 300);
    }
  }

  function handleEscKey(e) {
    if (e.key === "Escape") {
      hideComparison();
    }
  }
});
